export default {
  headerFont: 'Urbanist'
  , bodyFont: 'Urbanist'
  , legendFont: 'Urbanist'
  , chartColors: {
    bar: ['#e6e6e6', '#a0a0a0', '#ef3333']
    , pie: ['#a0a0a0', '#717373', '#ff633d']
  }
};
